import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/scss/themes.scss';
import ShowLoggedInErrorPopUP from './Components/Common/ShowLoggedInErrorPopUP';
import Route from './Routes';

function App() {
    const [showLoggedInError, setShowLoggedInError] = useState(false);

    return (
        <React.Fragment>
            <ToastContainer
                theme="colored"
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={true}
                limit={0}
            />
            <Route />
            <ShowLoggedInErrorPopUP isOpen={showLoggedInError} toggle={() => setShowLoggedInError(!showLoggedInError)} />
        </React.Fragment>
    );
}

export default App;
